const SITE = "https://wørdle.nu";

/** Norsk JSON-LD – Wordle (ikke Wørdle) som spillnavn, Wørdle.nu som utgiver */
export const NO_WEBPAGE = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Wordle på norsk",
  url: `${SITE}/no`,
  inLanguage: "no",
  description:
    "Spill Wordle på norsk. Gjett dagens ord på 6 forsøk. Gratis, uten innlogging, rett i nettleseren.",
  publisher: {
    "@type": "Organization",
    name: "Wørdle.nu",
    url: SITE,
  },
};

export const NO_FAQ = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Hva er Wordle på norsk?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Wordle på norsk er et ordspill der du gjetter et fem-bokstavers ord på maksimalt seks forsøk. Hver dag er det et nytt ord.",
      },
    },
    {
      "@type": "Question",
      name: "Hvordan spiller jeg?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Skriv et gyldig norsk ord på fem bokstaver og trykk enter. Grønn betyr riktig plass, gul betyr feil plass, grå betyr ikke i ordet.",
      },
    },
  ],
};
